import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { PlaceSearchResult } from '@app/components/pr-form/pr-input-map/pr-input-map.component';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { combineLatest } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'fiscal-address',
    templateUrl: './fiscal-address.component.html',
    styleUrls: ['./fiscal-address.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class FiscalAddressComponent implements OnInit {
  @Input() derrors = false;
  @Input() isSwisslifeProduct = false;
  countries: any[];
  departments: any[];
  toValue: PlaceSearchResult = { address: '' };

  constructor(
    private controlContainer: FormGroupDirective,
    private referenceDao: ReferenceDao,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {}

  ngOnInit() {
    combineLatest([this.referenceDao.getCountries()])
      .pipe(untilDestroyed(this))
      .subscribe(([countries]) => {
        this.countries = countries;
      });
  }
  get form() {
    return this.controlContainer.form;
  }
}
